export const normalizeDurationToSeconds = (duration, options = {}) => {
    if (duration === null || duration === undefined || duration === '') {
        return null;
    }

    const numericDuration = Number(duration);
    if (!Number.isFinite(numericDuration) || numericDuration <= 0) {
        return null;
    }

    const unitHint = options?.unitHint;
    if (unitHint === 'seconds') {
        return roundToTenth(numericDuration);
    }

    if (unitHint === 'milliseconds') {
        return roundToTenth(numericDuration / 1000);
    }

    let seconds;
    if (numericDuration >= 1000) {
        seconds = numericDuration % 1 !== 0 ? numericDuration : numericDuration / 1000;
    } else if (numericDuration >= 100) {
        if (numericDuration % 1 !== 0) {
            seconds = numericDuration;
        } else if (numericDuration / 1000 < 1) {
            seconds = numericDuration / 1000;
        } else {
            seconds = numericDuration;
        }
    } else {
        seconds = numericDuration;
    }

    return roundToTenth(seconds);
};

export const resolvePreferredMediaDuration = ({ storedDuration, runtimeDuration }) => {
    const normalizedStoredDuration = normalizeDurationToSeconds(storedDuration, { unitHint: 'seconds' });
    const normalizedRuntimeDuration = normalizeDurationToSeconds(runtimeDuration, { unitHint: 'seconds' });

    if (normalizedStoredDuration === null) {
        return normalizedRuntimeDuration;
    }

    if (normalizedRuntimeDuration === null) {
        return normalizedStoredDuration;
    }

    const durationDrift = Math.abs(normalizedRuntimeDuration - normalizedStoredDuration);
    const allowedDrift = Math.max(1.5, normalizedStoredDuration * 0.15);

    return durationDrift <= allowedDrift ? normalizedRuntimeDuration : normalizedStoredDuration;
};

function roundToTenth(value) {
    return Math.round(value * 10) / 10;
}
